import React from "react";
import { Star } from "@mui/icons-material";
import styled from "@emotion/styled";

export const AverageRating = ({ rating, votes, onClick }) => {
  return (
    <div
      css={{
        display: "flex",
        alignItems: "center",
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      {rating || "0.0"}
      <span css={{ padding: "0px 2px" }}>
        <StyledStar />
      </span>
      {` (${votes})`}
    </div>
  );
};

const StyledStar = styled(Star)`
  width: 18px;
  height: 18px;
  top: 3px;
  position: relative;
`;
